import { SceneSet } from '@bighealth/types';

export const getSessionSmallTitle = (sceneSet: SceneSet): string | undefined =>
  sceneSet?.session_small_title;
